const foundWays = [
  {
    name: "Through an online platform",
    value: "ONLINE_PLATFORM",
  },
  {
    name: "Through a direct contact with the company",
    value: "DIRECT_CONTACT",
  },
];

export default foundWays;
